export default __webpack_public_path__ + "static/media/updated-icon.8b5a4723.svg";